import { combineReducers } from 'redux';
import produce from 'immer';
import { ProcessAction, ProcessActionType } from '../../actions/processActions';
import { ProcessStatus } from '~/types/resources';

interface ProcessStatusState {
  byId: Record<string, ProcessStatus>;
  allIds: string[];
}

export const initialState: ProcessStatusState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: ProcessAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ProcessActionType.GET_PROCESS_STATUS_OK: {
        draft[action.data.id] = {
          ...action.data,
        };

        break;
      }
      case ProcessActionType.RESET_PROCESS_STATUS_OK: {
        draft[action.data.id] = {
          ...action.data,
        };

        break;
      }
      case ProcessActionType.LIST_PROCESS_STATUSES:
        return {};
      case ProcessActionType.LIST_PROCESS_STATUSES_OK: {
        action.data.forEach((status) => {
          draft[status.id] = {
            ...status,
          };
        });

        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: ProcessAction) => {
  switch (action.type) {
    case ProcessActionType.LIST_PROCESS_STATUSES:
      return [];
    case ProcessActionType.LIST_PROCESS_STATUSES_OK:
      return action.data.map((status) => status.id);
    case ProcessActionType.GET_PROCESS_OK:
      return state.includes(action.data.id) ? state : [...state, action.data.id];
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  allIds,
});
